import classnames from 'classnames';
import React, { isValidElement } from 'react';
import { WizardContextProvider } from "./Context.js";
import { Modal } from "../modal/Modal.js";
import { ModalFooter } from "../modal/components/modalFooter/ModalFooter.js";
import { Stepper } from "../stepper/Stepper.js";
import { StepItem } from "../stepper/components/stepItem/StepItem.js";
import styles from "./Wizard.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
export { useWizard } from "./Context.js";
export const Wizard = ({
  onStepChange,
  children,
  className,
  currentStep,
  setStep,
  onNext,
  onBack,
  ...modalProps
}) => {
  const _children = Array.isArray(children) ? children : [children];
  const titles = _children.map(child => /*#__PURE__*/isValidElement(child) ? child.props.title : null).filter(Boolean);
  const hasStepper = titles.length > 0;
  const currentChild = _children[currentStep];
  const wizardClasses = classnames(styles.wizard, className);
  return /*#__PURE__*/_jsx(Modal, {
    ...modalProps,
    className: wizardClasses,
    progress: hasStepper ? undefined : modalProps.progress,
    customProgress: hasStepper && /*#__PURE__*/_jsx(Stepper, {
      onBack: onBack,
      onNext: onNext,
      activeIndex: currentStep,
      children: titles.map((title, index) => /*#__PURE__*/_jsx(StepItem, {
        label: title
      }, index))
    }),
    children: /*#__PURE__*/_jsx(WizardContextProvider, {
      currentStep: currentStep,
      steps: _children.length,
      setStep: setStep,
      onStepChange: onStepChange,
      children: currentChild
    })
  });
};
export const WizardFooter = ({
  className,
  children
}) => {
  const footerClasses = classnames(styles.footer, className);
  return /*#__PURE__*/_jsx(ModalFooter, {
    className: footerClasses,
    children: children
  });
};